import { DocumentsContainer } from "./DocumentsContainer";
import { Checkmark } from "@carbon/icons-react";
import { DocumentItem } from "../../profile/documentcard/DocumentItem";
import React from "react";
import { ParticipantFileStatusCode } from "../../../../../types/components";
import { useTranslation } from "react-i18next";

interface UploadedDocumentsProps {
  documents_section: {
    title: string;
    description: string | undefined;
    fileType: string | undefined;
    status: ParticipantFileStatusCode;
  }[];
}

export const UploadedDocuments: React.FC<UploadedDocumentsProps> = ({ documents_section }) => {
  const { t } = useTranslation();

  return (
    <DocumentsContainer icon={Checkmark} title={t("Uploaded")}>
      <div className="flex flex-col justify-start gap-12">
        {documents_section.map(({ title, fileType, description, status }, index) => (
          <DocumentItem
            key={index}
            title={t(title)}
            description={description || ""}
            fileType={`${t("Supported file types")}: ${fileType || ""}`}
            status={status || "not_uploaded"}
          />
        ))}
      </div>
    </DocumentsContainer>
  );
};
